module.exports = __webpack_public_path__ + "img/com.samsung.android.oneconnect.d8a43130.webp";